module.exports = __webpack_public_path__ + "static/media/triunfo.a5fb086f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/driving/triunfo.png
// module id = 732
// module chunks = 0